<template>
  <div class="value-gain flex-box">
    <img v-lazy="jzsy" alt="" class="value-gain-bj">
    <div class="value-gain-title">{{ title }}</div>
    <div class="value-gain-description">{{ description }}</div>
    <div class="carousel-container">
      <div class="swiper-container1">
        <div class="swiper-wrapper1">
          <div v-for="(item, index) in caseList" class="swiper-slide1" :key="index">
            <div class="case-item pointer" :style="{ backgroundImage: `url(${item.img})` }">
              <div class="case-deco" aria-hidden="true">
                <img :src="item.img" alt="">
              </div>
              <div class="case-copy">
                <div class="item-num" v-if="item.num">{{ item.num }}</div>
                <div v-if="item.mark">
                  <span class="mark">{{ item.mark }}</span>
                </div>
                <div class="scope" v-if="item.scope">{{ item.scope }}<span>%</span></div>
                <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                <div class="descArr" v-if="item.descArr">
                  <div v-for="(subItem, ks) in item.descArr" :key="ks">{{ subItem }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jzsy from '@/assets/images/jzsy.png'
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    caseList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      jzsy
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.swiper-container1{
  width: 100%;
  height: 100%;
  .swiper-slide1{
    width: 32.7rem;
    margin: 0 2rem !important;
    display: inline-block;
  }
}

.value-gain {
  width: 100%;
  padding: 8rem 0 10.6rem 0;
  flex-direction: column;
  overflow-x: hidden;
  position: relative;

  .value-gain-bj {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .value-gain-title {
    height: 4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 4rem;
    color: #FFFFFF;
    line-height: 4rem;
    text-align: center;
    font-style: normal;
    margin-bottom: 2.4rem;
  }

  .value-gain-description {
    height: 2.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.8rem;
    color: #FFFFFF;
    line-height: 2.4rem;
    text-align: center;
    font-style: normal;
    margin-bottom: 6.6rem;
  }

  .carousel-container {
    width: 100%;
   
    .swiper-wrapper1 {
      width: calc(192rem - 45rem);
      text-align: center;
      margin: 0 auto;
    }

    .case-deco {
      display: none;
    }

    .case-item {
      width: 32.7rem;
      height: 36rem;
      padding: 3.7rem 0 0 6.3rem;
      position: relative;
      background-size: cover!important;
      background-repeat: no-repeat!important;
      text-align: left;

      .item-num {
        position: absolute;
        left: 3.6rem;
        top: 3.2rem;
        opacity: .1;
        font-weight: bold;
        font-size: 7.2rem;
        color: #3674FE;
        line-height: 7.2rem;
        text-align: left;
        font-style: normal;
      }

      .mark {
        background: #E6EEFF;
        border-radius: 1.4rem;
        padding: .6rem 1.6rem;
        display: inline-block;

        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 1.4rem;
        color: #3674FE;
        line-height: 1.6rem;
        text-align: center;
        font-style: normal;
      }
      .scope {
        height: 7.2rem;
        font-family: DINAlternate, DINAlternate;
        font-weight: bold;
        font-size: 7.2rem;
        color: #3674FE;
        line-height: 7.2rem;
        text-align: left;
        font-style: normal;
        margin-top: .5rem;
        span {
          width: 2.5rem;
          height: 7.2rem;
          font-family: Din;
          font-weight: bold;
          font-size: 4.8rem;
          color: #666A77;
          line-height: 7.2rem;
          text-align: left;
          font-style: normal;
          padding-left: .8rem;
        }
      }
      .desc {
        margin-top: 1.2rem;
        height: 2.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 2.4rem;
        color: #333333;
        line-height: 2.4rem;
        font-style: normal;
      }
      .descArr {
        position: absolute;
        left: 3.6rem;
        top: 7rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 3.2rem;
        color: #333333;
        line-height: 4.8rem;
        text-align: left;
        font-style: normal;
      }

     
    }

  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .value-gain {
    padding: 4.8rem 1.6rem 6.4rem;
    overflow-x: hidden;
    .value-gain-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      height: auto;
      padding: 0;
    }
    .value-gain-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      height: auto;
      padding: 0;
      margin-bottom: 2.4rem;
    }
    .swiper-container1 {
      width: 100%;
      height: auto;
    }
    .carousel-container .swiper-wrapper1,
    .swiper-wrapper1 {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-auto-rows: 1fr;
      align-items: stretch;
      gap: 1.2rem;
      width: 100%;
      max-width: 100%;
      margin: 0;
      text-align: left;
    }
    .swiper-container1 .swiper-slide1,
    .carousel-container .swiper-slide1,
    .swiper-slide1 {
      display: flex;
      width: 100% !important;
      max-width: 100%;
      height: 100%;
      margin: 0 !important;
      float: none;
    }
    .carousel-container .case-item,
    .case-item {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      min-height: 12rem;
      margin: 0;
      padding: 1.6rem 1.2rem 4rem 1.2rem;
      box-sizing: border-box;
      text-align: left;
      overflow: visible;
      background-color: #fff;
      background-size: cover;
      background-position: right bottom;
      background-repeat: no-repeat;
      .item-num {
        left: 0.8rem;
        top: 0.8rem;
        font-size: 3.2rem;
        line-height: 3.2rem;
      }
      .mark {
        font-size: 1.2rem;
        padding: 0.4rem 0.8rem;
      }
      .scope {
        height: auto;
        font-size: 3.2rem;
        line-height: 3.6rem;
        margin-top: 0.4rem;
        span {
          width: auto;
          height: auto;
          font-size: 2rem;
          line-height: 3.6rem;
        }
      }
      .desc {
        margin-top: 0.8rem;
        height: auto;
        font-size: 1.4rem;
        line-height: 2rem;
        white-space: normal;
        word-break: break-word;
      }
      .descArr {
        position: relative;
        left: auto;
        top: auto;
        font-size: 1.4rem;
        line-height: 2rem;
        white-space: normal;
        word-break: break-word;
      }
    }
    .carousel-container .case-deco {
      display: none;
    }
  }
}
</style>
